/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';

import { Modal } from '@/components/Modal';

import { ClassCategory, EnrolmentForm } from './EnrolmentForm';

export const ClassCategories: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<ClassCategory | ''>(
    '',
  );

  const openModal = () => {
    setIsFormOpen(true);
  };

  const closeModal = () => {
    setIsFormOpen(false);
  };

  const handleEnrolBtn = () => {
    // If you don’t need categories, you can remove this line
    setSelectedCategory('' as ClassCategory);
    openModal();
  };

  return (
    <>
      <div className='flex justify-center w-full px-8 mt-4'>
        <button
          onClick={handleEnrolBtn}
          type='button'
          className='bg-indigo mt-8 hover:bg-yellow text-[14px] h-[40px] min-w-[200px] p-2 rounded-md text-white'
        >
          Apply Now
        </button>
      </div>

      <Modal isOpen={isFormOpen} closeModal={closeModal}>
        <EnrolmentForm
          classCategory={selectedCategory}
          closeForm={closeModal}
        />
      </Modal>
    </>
  );
};
